import {
    Avatar,
    Box,
    Button,
    Card,
    CardHeader,
    Grid,
    IconButton,
    InputBase,
    Pagination,
    Paper,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/styles';
import SubCard from 'ui-component/cards/SubCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';
import ViewInoiceCustomer from './ViewInoiceCustomer';
import moment from 'moment';
import ReactMoment from 'react-moment';
import CoinAoneDark200 from '../../../assets/images/CoinAoneDark200.png';
import CoinSamsungDark200 from '../../../assets/images/CoinSamsungDark200.png';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import { exportToCSV } from 'ui-component/exportToCSV';
import MessageBox from 'ui-component/MessageBox';
import ImagePreview from 'ui-component/ImagePreview';
import SettingsIcon from '@mui/icons-material/Settings';
import InvoiceSetting from './InvoiceSetting';
export const InvoiceCustomer = () => {
    const [openBackdrop, setopenBackdrop] = useState(false);
    const [OpenSetting, setOpenSetting] = useState(false);
    const theme = useTheme();
    const [BillData, setBillData] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [page, setpage] = useState(1);
    const [total, settotal] = useState(0);
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [ValueSearch, setValueSearch] = useState('');
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [SelectedData, setSelectedData] = useState({});
    const handlePage = (event, value) => {
        setpage(value);
    };
    const columns = [
        // { field: '_id', headerName: 'id', width: 90 },

        {
            field: 'invoiceNumber',
            headerName: 'Invoice Number',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="button"
                    gutterBottom
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    {params.row.invoiceNumber}
                </Typography>
            )
        },
        {
            field: 'customer',
            headerName: 'customer',
            width: 140,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Stack>
                    <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customerID}
                    </Typography>
                    <Typography variant="caption" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customers.customerName}
                    </Typography>
                </Stack>
            )
        },
        // {
        //     field: 'wallet',
        //     headerName: 'Wallet Payment',
        //     width: 150,
        //     // flex: 0.5,
        //     // editable: true,
        //     sortable: false,
        //     filterable: false,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Stack>
        //             <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinAoneDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#3035BC',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={params.row.aonewallets !== null ? params.row.aonewallets.totalPayment : 0}
        //                         prefix="$"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button>
        //             <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinSamsungDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#000',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={0}
        //                         prefix="$"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button>
        //         </Stack>
        //     )
        // },
        {
            field: 'totalPayment',
            headerName: 'Total',
            width: 120,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="body1"
                    color="#f57224"
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={params.row.totalPayment}
                        prefix="₭"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                    />
                </Typography>
            )
        },
        {
            field: 'Amount',
            headerName: 'Amount',
            width: 100,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="button"
                    gutterBottom
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    {params.row.stockController.length}
                </Typography>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            // editable: true,
            renderCell: (params) => {
                return (
                    <Typography
                        variant="button"
                        gutterBottom
                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                    >
                        {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
                    </Typography>
                );
            }
        },
        // {
        //     field: 'saleBy',
        //     headerName: 'SaleBy',
        //     width: 200,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
        //             {params.row.saleBy}
        //         </Typography>
        //     )
        // },
        {
            field: 'Reference',
            headerName: 'reference',
            // type: 'number',
            width: 160,
            sortable: false,
            filterable: false,
            // headerAlign: 'center',
            // align: 'center',
            // editable: true
            renderCell: (params) => {
                return (
                    <Stack alignItems="center" justifyContent="center">
                        <Typography variant="body2" noWrap gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                            {params.row.reference}
                        </Typography>

                        <IconButton
                            // sx={{ p: '10px' }}
                            color="primary"
                            aria-label="Image"
                            onClick={() => {
                                // console.log(params.row._id);
                                PreviewImageReference(params.row._id);
                            }}
                        >
                            <ImageIcon />
                        </IconButton>
                    </Stack>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            // flex: 0.5,
            width: 160,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        // color="primary"
                        sx={{ color: '#0c4da2' }}
                        onClick={() =>
                        {
                            console.log(params.row);
                            setSelectedData(params.row);
                            setOpenInvoice(true);
                        }}
                    >
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton
                        variant="contained"
                        color="success"
                        onClick={(e) => {
                            // console.log(params.row);
                            exportToCSV(params.row.stockController, params.row.invoiceNumber);
                        }}
                    >
                        <DescriptionIcon />
                    </IconButton>
                </Stack>
            )
            // editable: true
        }
    ];
    const PreviewImageReference = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/stockcustomer/referenceimage/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                // console.log(Preview.data.data);
                MessageBox.open({
                    title: 'Preview',
                    content: <ImagePreview images={[Preview.data.data?.referenceImage]} />,
                    buttons: [{ name: 'Close', handler: () => true }]
                });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
        }
        setopenBackdrop(false);
    };
    async function LoadData(ValueFind) {
        try {
            setBillData([]);
            setopenBackdrop(true);
            const valueReplate = ValueFind === '' ? '^' : ValueFind.toLowerCase();

            const response = await axios.get(ApiLink + '/api/stockcustomer/invoice/' + valueReplate + '/' + page, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setBillData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    useEffect(() => {
        LoadData(ValueSearch);
    }, []);
    useEffect(() => {
        LoadData(ValueSearch);
    }, [page]);
    return (
        // <MainCard>
        <Grid container spacing={2}>
            <div id="app-message-box" />
            <InvoiceSetting open={OpenSetting} setOpen={setOpenSetting} loadData={LoadData} />
            <ViewInoiceCustomer Open={OpenInvoice} setOpen={setOpenInvoice} DataInvoice={SelectedData} />
            <Grid item xs={12}>
                <SubCard
                    title="Invoice List"
                    contentSX={{ p: 0 }}
                    show={true}
                    secondary={
                        <Stack direction="row" spacing={1}>
                            <IconButton
                                color="success"
                                aria-label="Edit Footer"
                                onClick={() => {
                                    setOpenSetting(true);
                                }}
                            >
                                <SettingsIcon />
                            </IconButton>
                            <Paper style={{ display: 'flex', width: matchDownSM ? 180 : 300 }} elevation={2}>
                                <InputBase
                                    type="text"
                                    fullWidth
                                    disabled={openBackdrop}
                                    style={{
                                        marginLeft: 1,
                                        flex: 1,
                                        fontFamily: 'boonhome-400'
                                    }}
                                    value={ValueSearch}
                                    onChange={(event) => {
                                        setValueSearch(event.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.keyCode == 13) {
                                            setpage(1);
                                            LoadData(ValueSearch);
                                        }
                                    }}
                                    placeholder="Invoice Number"
                                    inputProps={{ 'aria-label': 'Invoice Number' }}
                                    endAdornment={
                                        <IconButton
                                            disabled={openBackdrop}
                                            className="iconbutton"
                                            aria-label="search"
                                            onClick={(e) => {
                                                setpage(1);
                                                LoadData(ValueSearch);
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    }
                                    startAdornment={
                                        <IconButton
                                            disabled={openBackdrop}
                                            className="iconbutton"
                                            aria-label="refresh"
                                            onClick={() => {
                                                // setData(dataOriginal);
                                                setValueSearch('');
                                                LoadData('');
                                            }}
                                        >
                                            <RefreshIcon />
                                        </IconButton>
                                    }
                                />
                            </Paper>
                        </Stack>
                    }
                >
                    <Box
                        // style={{
                        //     width: '100%',
                        //     height: '80vh',
                        //     textAlign: 'center'
                        //     // overflow: "auto",
                        // }}
                        sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}
                    >
                        <StyledDataGrid
                            loading={openBackdrop}
                            getRowId={(row) => row._id}
                            rows={BillData}
                            columns={columns}
                            //pageSize={20}
                            rowHeight={100}
                            headerHeight={60}
                            hideFooter={true}
                        />
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        <Pagination
                            disabled={openBackdrop}
                            count={totalPage}
                            // variant="outlined"
                            page={page}
                            size="small"
                            shape="rounded"
                            color="primary"
                            onChange={handlePage}
                            showFirstButton
                            showLastButton
                        />
                    </Box>
                    <p
                        style={{
                            fontSize: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        Total : {total}
                    </p>
                </SubCard>
            </Grid>
        </Grid>
        // </MainCard>
    );
};
